import { getStylesObjFromCss } from "../../../../../utils/common/styling";

export const styles = getStylesObjFromCss({
  styles: {
    root: {
      width: "100%",
      margin: "2px 0",
      borderRadius: "16px",
      cursor: "pointer",
      transition: "all 0.2s ease-in-out",
    },

    active: {
      border: "2px solid #E5E5E5",
      backgroundColor: "#fff",
      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
      transform: "scale(1.01)",
      margin: "-3px 0",
      zIndex: 20,
    },

    inactive: {
      border: "1px solid transparent",
    },

    draggable: {
      opacity: 0.8,
    },

    container: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      padding: "0 16px",
      height: "48px",
    },

    left: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      flex: 1,
    },

    right: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
    },

    actions: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      "& svg": {
        color: "#948AD9",
      },
    },

    dragHandle: {
      cursor: "grab",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    dragCta: {
      cursor: "grab",
    },
  },
  componentName: "MovableSectionCTA",
});
